/** @file Picks indexed by drawable id. */
import type { FacetPick } from '@zilo/pose3d-facet/contract';

/** `pick.drawable -> pick`; a later pick for the same drawable wins. */
export function pickByDrawable(picks: FacetPick[]): Map<string, FacetPick> {
  return new Map(picks.map((p) => [p.drawable, p] as const));
}
